"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_content_loader_1 = tslib_1.__importDefault(require("react-content-loader"));

var styles = tslib_1.__importStar(require("./ThumbsSkeleton.style"));

var ThumbsSkeleton = function ThumbsSkeleton(props) {
  return jsx_runtime_1.jsx("div", Object.assign({
    css: styles.container
  }, {
    children: jsx_runtime_1.jsxs(react_content_loader_1.default, Object.assign({
      speed: 2,
      width: 984,
      height: 1024,
      viewBox: "0 0 984 1024",
      backgroundColor: "#343a40",
      foregroundColor: "#666d75"
    }, props, {
      children: [jsx_runtime_1.jsx("rect", {
        x: "80",
        y: "94",
        rx: "4",
        ry: "4",
        width: "824",
        height: "520"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "472",
        y: "630",
        rx: "4",
        ry: "4",
        width: "40",
        height: "20"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "80",
        y: "665",
        rx: "4",
        ry: "4",
        width: "124",
        height: "93"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "220",
        y: "665",
        rx: "4",
        ry: "4",
        width: "124",
        height: "93"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "359",
        y: "665",
        rx: "4",
        ry: "4",
        width: "124",
        height: "93"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "499",
        y: "665",
        rx: "4",
        ry: "4",
        width: "124",
        height: "93"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "638",
        y: "665",
        rx: "4",
        ry: "4",
        width: "124",
        height: "93"
      }, void 0), jsx_runtime_1.jsx("rect", {
        x: "778",
        y: "665",
        rx: "4",
        ry: "4",
        width: "124",
        height: "93"
      }, void 0)]
    }), void 0)
  }), void 0);
};

exports.default = ThumbsSkeleton;